import { render, staticRenderFns } from "./SVGSunShine.vue?vue&type=template&id=63f8ad36&scoped=true&"
import script from "./SVGSunShine.vue?vue&type=script&lang=js&"
export * from "./SVGSunShine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8ad36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63f8ad36')) {
      api.createRecord('63f8ad36', component.options)
    } else {
      api.reload('63f8ad36', component.options)
    }
    module.hot.accept("./SVGSunShine.vue?vue&type=template&id=63f8ad36&scoped=true&", function () {
      api.rerender('63f8ad36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGSunShine.vue"
export default component.exports